import { useEffect, useState } from "react";
import { GoHome } from "react-icons/go";
import { BsCalendarDate, BsFillCloudFill, BsBuilding } from "react-icons/bs";
import {
  MdAttachEmail,
  MdClose,
  MdHelp,
  MdOutlineQrCode2,
  MdOutlineBrowserUpdated,
} from "react-icons/md";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { styled } from "@mui/material/styles";

import { Link } from "react-router-dom";
import LogoPGJEM from "assets/images/logo_poder_judicial.png";
import Image1 from "assets/images/icon1.png";
import LogoConfia from "assets/images/botonConfia.png";
import { List, IconButton, Box, Typography, Button } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { useNavigate } from "react-router-dom";
import { TbReport } from "react-icons/tb"; //eslint-disable-next-line
import { FiPlay, FiVideo } from "react-icons/fi";
import { AiFillBook } from "react-icons/ai";
import { RiProfileLine, RiListCheck3 } from "react-icons/ri";
import { FaGavel } from "react-icons/fa";
import { SidenavOptions } from "./components/sidenavOptions";
import { useUiStore } from "hooks/useUiStore";
import { useHomeStore } from "hooks/useHomeStore";
import { formRedirectRegistroCitas } from "helpers/formsredirect";
import { useAuthStore } from "hooks/useAuthStore";
import { useAppDispatch } from "hooks/reduxHooks";
import { onModalOpen } from "store/servicioWhatsapp/servicioWhatsappSlice";
import Swal from "sweetalert2";
import VideoModal from "./ModalVideoCitasTribunal"; //eslint-disable-next-line
import { BusquedaForm } from "components/busqueda/busquedaForm";
import { FaFolder } from "react-icons/fa";
import IconoConfia from "assets/images/iconoConfia.png";
import IconoDarkConfia from "assets/images/iconoConfiaHum.png";

const drawerWidth = 280;

const ListCustomDropdown = styled(List)<{ component?: React.ElementType }>({
  "& .MuiListItemButton-root": {
    marginLeft: 5,
    marginRight: 5,
  },
  "& .MuiListItemIcon-root": {
    background: "bg-white",
    borderRadius: "9px",
    boxShadow: "-1px 4px 23px 3px rgba(0,0,0,0.15);",
    width: "30px",
    minWidth: "10px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "15px",
  },
  "& .MuiTypography-root": {
    fontSize: "0.875rem",
    lineHeight: "1.5",
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  width: `calc(100% - ${drawerWidth}px)`,
  marginLeft: `${drawerWidth}px`,
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.enteringScreen,
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  border: "none",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const Sidenav = () => {
  const { openDrawer, darkMode, handleOpenDrawer } = useUiStore();
  const { changeHomeInitial } = useHomeStore();
  const [selectedIndex, setSelectedIndex] = useState(
    Number(localStorage.getItem("selectedIndex"))
  );
  const [path, setPath] = useState<string>("");

  const navigate = useNavigate();

  const { user } = useAuthStore();
  const dispatch = useAppDispatch();
  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setPath(String(localStorage?.getItem("lastpath")));
    localStorage.setItem("lastpath", String(localStorage?.getItem("lastpath")));
    localStorage.setItem("selectedIndex", JSON.stringify(index));
    setSelectedIndex(index);
  };

  useEffect(() => {
    if (
      path !== "" &&
      selectedIndex !== 2 &&
      localStorage?.getItem("lastpath")?.includes("expediente")
    ) {
      localStorage.setItem("lastpath", path);
      navigate(path);
      setTimeout(() => {
        setPath("");
      }, 250);
    } /* eslint-disable-next-line */
  }, [path, selectedIndex]);

  let listRoutes = [
    {
      id: 1,
      title: "Inicio",
      icon: <GoHome />,
      path: "/dashboard/inicio",
      children: [],
    },
    {
      id: 2,
      title: "Expediente Electrónico",
      icon: <FaFolder />,
      path: "/dashboard/expediente-electronico",
      children: [],
    },
    {
      id: 3,
      title: "Sitios de interés",
      icon: <BsFillCloudFill />,
      onclick: () => changeHomeInitial(),
      children: [
        {
          id: 1.1,
          title: "Poder Judicial",
          path: "https://www.pjedomex.gob.mx/vista/1_inicio",
          icon: <FaGavel />,
          isExternal: true,
        },
        {
          id: 1.2,
          title: "Boletín Judicial",
          path: "http://notificacion.pjedomex.gob.mx/notificacion/vista/php/consultaServiciosBoletin.php",
          icon: <RiProfileLine />,
          isExternal: true,
        },
        {
          id: 1.3,
          title: "Correo Institucional",
          path: "https://mail.pjedomex.gob.mx/",
          icon: <MdAttachEmail />,
          isExternal: true,
        },
        {
          id: 1.4,
          title: "Libro Indice",
          path: "sitios-interes/libro-indice",
          icon: <AiFillBook />,
          isExternal: false,
        },
        {
          id: 1.5,
          title: "Registro de Citas",
          path: process.env.REACT_APP_URL_REGISTRO_CITAS,
          icon: <BsCalendarDate />,
          isExternal: true,
          onClickAction: () =>
            formRedirectRegistroCitas(
              process.env.REACT_APP_URL_REGISTRO_CITAS
                ? process.env.REACT_APP_URL_REGISTRO_CITAS
                : "",
              user.session?.cveUsuario
            ),
        },
        {
          id: 1.6,
          title: "Notificación via WhatsApp",
          path: "Notificación via WhatsApp",
          icon: <AiOutlineWhatsApp />,
          isExternal: false,
          onClickAction: () => dispatch(onModalOpen(true)),
        },
      ],
    },
    {
      id: 4,
      title: "Mis reportes",
      icon: <MdHelp />,
      children: [
        {
          id: 2.1,
          title: "Reportar",
          path: "mis-reportes/reportar",
          icon: <TbReport />,
          isExternal: false,
        },
        {
          id: 2.2,
          title: "Seguimiento",
          path: "mis-reportes/seguimiento",
          icon: <RiListCheck3 />,
          isExternal: false,
        },
        {
          id: 2.3,
          title: "CONFÍA",
          path: "https://confia.pjedomex.gob.mx/solicitudes",
          icon: (
            <img
              src={darkMode === "light" ? IconoDarkConfia : IconoConfia}
              alt="Confía"
              style={{
                width: 25,
                height: 30,
              }}
            />
          ),
          isExternal: true,
        },
      ],
    },
    {
      id: 6,
      title: "Requerimientos del Sistema",
      icon: <MdOutlineBrowserUpdated />,
      path: "/dashboard/requerimientos-sistema/",
      children: [],
    },
    {
      id: 7,
      title: "Videos Tutoriales",
      icon: <FiVideo />,
      children: [
        {
          id: 4.1,
          title: "Boletín Judicial & Libro Índice",
          path: "video-tutorial/boletinLibro",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 4.2,
          title: "Cambio de Contraseña",
          path: "video-tutorial/cambioContra",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 4.3,
          title: "Registro de Citas",
          path: "video-tutorial/registroCitas",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 4.4,
          title: "Conoce tu Tribunal",
          path: "video-tutorial/conoceTuTribunal",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 4.5,
          title: "Consulta Expediente Electrónico",
          path: "video-tutorial/consultaElectronico",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 4.6,
          title: "Demanda",
          path: "video-tutorial/demanda",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 4.7,
          title: "Firma a través de Correo Electrónico",
          path: "video-tutorial/firmaCorreo",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 4.8,
          title: "Promoción",
          path: "video-tutorial/promocion",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 4.9,
          title: "Registro vía WhatsApp",
          path: "video-tutorial/registroWhatsapp",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 4.1,
          title: "Reporte & Seguimiento",
          path: "video-tutorial/reporteSeguimiento",
          icon: <FiPlay />,
          isExternal: false,
        },
        {
          id: 5,
          title: "Desactivar Traductor Automático del Navegador",
          path: "video-tutorial/traductorAutoNavegador",
          icon: <FiPlay />,
          isExternal: false,
        },
      ],
    },

    // {
    //   id: 5,
    //   title: "Test Notificaciones",
    //   icon: <AiFillAlert />,
    //   path: "/dashboard/sitios-interes/test-notificaciones",
    //   children: [],
    // },
  ];
  if (user.session?.cveUsuario === 96) {
    listRoutes.push({
      id: 5,
      title: "Acceso a Edificios",
      icon: <BsBuilding />,
      children: [
        {
          id: 3.1,
          title: "Generar mi Acceso",
          path: "accesos-edificios/genera-acceso",
          icon: <MdOutlineQrCode2 />,
          isExternal: false,
        },
      ],
    });
  }
  const handleClickVersionWeb = () => {
    Swal.fire({
      title: "¿Necesitas ayuda con algún inconveniente?",
      html: `<p style="font-size:16px;text-align: center;">Nuestro equipo de soporte está disponible para ayudarte. Contáctanos en Mesa de ayuda. 722 167 92 00 Ext. 15401</p>`,
      icon: "question",
    });
  };
  const handleClickConfia = () => {
    Swal.fire({
      title: "¿Qué es CONFÍA?",
      html: `<p style="font-size:16px;text-align: center;">En CONFÍA podrás presentar sugerencias, comentarios y peticiones, con el objetivo de mejorar el servicio de impartición de justicia. ¿Deseas continuar?</p>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        window.open(
          "https://confia.pjedomex.gob.mx/solicitudes",
          "_blank",
          "noopener,noreferrer"
        );
      }
    });
  };
  return (
    <Box
      component="nav"
      sx={{
        width: { sm: drawerWidth },
        flexShrink: { sm: 0 },
        border: "none",
      }}
      aria-label="mailbox folders"
    >
      <Drawer
        variant="permanent"
        open={openDrawer}
        sx={{
          border: "none",
          display: {
            xl: openDrawer ? "block" : "none",
            lg: openDrawer ? "block" : "none",
            xs: openDrawer ? "block" : "none",
            sm: openDrawer ? "block" : "none",
            md: openDrawer ? "block" : "none",
          },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: "80" },
        }}
      >
        <DrawerHeader>
          <div className="h-24 flex justify-center items-center">
            <Link
              className="block px-8 py-6 m-0 text-sm whitespace-nowrap"
              to="/"
            >
              <img
                src={LogoPGJEM}
                className="inline h-full max-w-full transition-all duration-200 ease-nav-brand max-h-8"
                alt="main_logo"
              />
              <button
                className="ml-1 font-semibold transition-all duration-200 ease-nav-brand"
                onClick={() => {
                  changeHomeInitial();
                }}
              >
                Tribunal Electrónico
              </button>
            </Link>
            {openDrawer ? (
              <IconButton
                onClick={() => handleOpenDrawer(false)}
                sx={{ fontSize: "30px" }}
              >
                <MdClose />
              </IconButton>
            ) : null}
          </div>
        </DrawerHeader>
        <div className="items-center block w-auto max-h-screen  overflow-y-auto h-sidenav grow basis-full h-full section menuComponent">
          <ListCustomDropdown
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            {listRoutes.map((route, index) => (
              <SidenavOptions
                route={route}
                key={route.id}
                index={index}
                handleListItemClick={handleListItemClick}
                selectedIndex={selectedIndex}
              />
            ))}
          </ListCustomDropdown>
          <BusquedaForm />
          <VideoModal />{" "}
          <Box
            component="div"
            sx={{
              background:
                "linear-gradient(to left bottom, #fb959c, #e98388, #d77074, #c45f60, #b24d4d, #a33f47, #943241, #85243b, #731a3d, #5f133d, #4b0f3b, #360c36)",
              padding: "20px",
              borderRadius: "20px",
              margin: "85px 20px 20px",
              textAlign: "center",
              width: "250px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              height: "100px",
              "&::before": {
                position: "absolute",
                content: `" "`,
                top: "0.3125rem",
                left: "1.875rem",
                width: "1.0625rem",
                backgroundImage: `url(${Image1})})`,
              },
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontSize: "13px", lineHeight: "1.4", color: "#ffffff" }}
            >
              ¿Problemas con esta versión?
            </Typography>
            <Button
              variant="contained"
              type="button"
              onClick={handleClickVersionWeb}
            >
              Mesa de ayuda
            </Button>
          </Box>
          <Box
            sx={{
              borderRadius: "20px",
              margin: "10px 20px 20px",
              textAlign: "center",
              width: "250px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              height: "150px",
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundImage: `url(${LogoConfia})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundColor: darkMode === "light" ? "#fceeee" : "#35416a",
                width: "250px",
                height: "100px",
                borderRadius: "20px",
                "&:hover": {
                  backgroundColor: darkMode === "light" ? "#6f1e26" : "#3f6cb2",
                },
              }}
              type="button"
              onClick={handleClickConfia}
            ></Button>
          </Box>
        </div>
      </Drawer>
    </Box>
  );
};
